import { render, staticRenderFns } from "./modificationOfWeigh.vue?vue&type=template&id=053ddc5e&scoped=true&"
import script from "./modificationOfWeigh.vue?vue&type=script&lang=js&"
export * from "./modificationOfWeigh.vue?vue&type=script&lang=js&"
import style0 from "./modificationOfWeigh.vue?vue&type=style&index=0&id=053ddc5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ddc5e",
  null
  
)

export default component.exports